import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import AuctionDetail from "@/pages/AuctionDetail";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyAccount from "@/pages/VerifyAccount";
import BuyerDashboard from "@/pages/BuyerDashboard";
import SellerDashboard from "@/pages/SellerDashboard";
import Disputes from "@/pages/Disputes";
import TrustSafety from "@/pages/TrustSafety";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import Compare from "@/pages/Compare";
import Business from "@/pages/Business";
import SellerProfile from "@/pages/SellerProfile";
import FAQ from "@/pages/FAQ";
import EmailSent from "@/pages/EmailSent";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import HowItWorks from "@/pages/HowItWorks";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/auctions" element={<Browse />} />
                            <Route path="/compare" element={<Compare />} />
                            <Route path="/business" element={<Business />} />
                            <Route path="/how-it-works" element={<HowItWorks />} />
                            <Route path="/auctions/:id" element={<AuctionDetail />} />
                            <Route path="/seller/:id" element={<SellerProfile />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/signup" element={<Signup />} />
                            <Route path="/account/verify" element={<VerifyAccount />} />
                            <Route path="/account/email-sent" element={<EmailSent />} />
                            <Route path="/account/forgot-password" element={<ForgotPassword />} />
                            <Route path="/account/reset-password" element={<ResetPassword />} />
                            <Route path="/dashboard/buyer" element={<BuyerDashboard />} />
                            <Route path="/dashboard/seller" element={<SellerDashboard />} />
                            <Route path="/disputes" element={<Disputes />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                            <Route path="/trust-safety" element={<TrustSafety />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/legal/:doc" element={<Legal />} />
                            <Route path="/payment/success" element={<PaymentSuccess />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
